module.exports = __webpack_public_path__ + "static/media/green-hex.e595bed7.png";